
//@ts-ignore
import {buyApi} from '../contract/buy.ts'

import {purchaseApi,loopBuyVipApi,getConfigApi,getUserSignnatureApi,createWalletAddressApi} from '../api/index'

import type { ExternalProvider,JsonRpcFetchFunc,Web3Provider} from "@ethersproject/providers";

import { BaseConfig, SdkOption, toHex } from "../helpers";

import getLibrary from '../lib/getProvider' 

import {BigNumber} from '@ethersproject/bignumber'

import { formatUnits,parseUnits,formatEther,parseEther} from '@ethersproject/units'

import { Buy } from '../contract/types';

import {contractAddress,IS_TEST_NET,SUPPORT_CHAIN_DATA, WEB3_USER_INFO,WEB3_SDK_SUPPORT_CHAIN_ID} from '../constants'

import contract from '../lib/contract';

import { Logger } from "@ethersproject/logger";
//@ts-ignore
import pkg from '../../package.json'

import Web3Modal, { EventController, getLocal, openMetaMaskUrl, removeLocal, setLocal } from "web3mdoal-customer";

import Fortmatic from "fortmatic";

import CoinbaseWalletSDK from "@coinbase/wallet-sdk";

import WalletConnectProvider from "@walletconnect/web3-provider";
//@ts-ignore
const parseInt =  require('lodash.parseint');

const logger = new Logger(pkg.name+"@"+pkg.version);

interface ResultData {
  code:number,
  result:any,
  message:string;
}

interface Signature {
  signatureMsg:string
}

interface UserInfo {
  avatar:string;
  nickname:string;
  token:string;
  userId:number;
}

interface ConnectResult {
  provider:ExternalProvider | JsonRpcFetchFunc;
  userInfo:UserInfo;
  address:string;
}
enum LocalStoragePrefix {
  Class = "class_",
}
const makeAutoSaveLocalStorage = (target: any) => {
  Object.getOwnPropertyNames(target).forEach((propertyKey) => {
    if (typeof target[propertyKey] !== "function" && Object.prototype.toString.call(target[propertyKey] !=='[object Object]')) {
      let property = target[propertyKey];
      Object.defineProperty(target, propertyKey, {
        set: (v) => {
          console.log('vvvvvvvvvv',v,Object.prototype.toString.call(target[propertyKey]) )

          const localJson = localStorage.getItem(
            LocalStoragePrefix.Class + target.constructor.name
          );
          // localStorage.setItem(
          //   LocalStoragePrefix.Class + target.constructor.name,
          //   JSON.stringify(
          //     Object.assign(JSON.parse(localJson != null ? localJson : "{}"), {
          //       [propertyKey]: v,
          //     })
          //   )
          // );
          property = v;
        },
        get: () => property,
      });
    }
  });
};

export class Core {
  private eventController: EventController = new EventController();
  /**
   *
   *
   * @private
   * @type {(ExternalProvider | JsonRpcFetchFunc)}
   * @memberof Core
   */
  public provider:ExternalProvider | JsonRpcFetchFunc;
  /**
   *
   *
   * @private
   * @type {Web3Provider}
   * @memberof Core
   */
  private library:Web3Provider;
  /**
   *
   *
   * @private
   * @type {number}
   * @memberof Core
   */
  public chainId:number;
  /**
   * Creates an instance of Core.
   * @param {SdkOption} opts
   * @memberof Core
   */
  private timerList:any[];
   /**
    * Creates an instance of Core.
    * @param {any} timerList
    * @memberof Core
    */
  private token:string;
    /**
     * Creates an instance of Core.
     * @param {string} token
     * @memberof Core
     */
  private config:BaseConfig;
    /**
     * Creates an instance of Core.
     * 
     * @memberof Core
     */
  public web3Modal:Web3Modal;

  public account:string;

  private options:SdkOption;

  private active:Boolean;
  
  constructor(opt:SdkOption) {

    this.provider  = {} as ExternalProvider | JsonRpcFetchFunc;

    this.library = {} as Web3Provider;

    this.chainId = 0;

    this.options = opt;

    this.token = (getLocal('WEB3_USER_INFO') as UserInfo)?.token || '';

    this.timerList = [];

    this.config  = {} as BaseConfig;
    
    this.account = '';

    this.active = false;

    if(!this.options.site){

      logger.throwArgumentError("缺少site", "site", null);

    }
     this.web3Modal  = this.initWeb3();

     const cachedProvider =  this.web3Modal.cachedProvider;

     if (cachedProvider) {

      this.connect();
    }

    // makeAutoSaveLocalStorage(this)

  }
  public get getChainId ():number{

    return this.chainId

  }
  public set setChainId (chainId:number){

     this.chainId = chainId

  }
  public connectWallet = async ():Promise<ConnectResult>=>{

    await this.web3Modal.clearCachedProvider();

    return new Promise(async (resolve, reject) => {


      try {
        this.provider =  await this.connect()

        this.library = getLibrary(this.provider)
  
        const accounts = await this.library.listAccounts();
  
        this.account = accounts[0] as string
  
        const {result} = await getUserSignnatureApi.query<Signature>({data:{address:this.account}})
  
        //@ts-ignore
        const signature:string = await this.library.provider.request({
          method: "personal_sign",
          params: [result.signatureMsg, this.account],
        });
  
        const {result:userInfo} =await createWalletAddressApi.create<UserInfo>({data:{address: this.account, signature: signature , signatureMsg: result.signatureMsg,site:this.options.site}})
  
        setLocal(WEB3_USER_INFO,userInfo)
        
        resolve({
          provider:this.provider,
          userInfo:userInfo,
          address:this.account
        })
      } catch (error) {
         this.resetApp()
      }

    

    })
    

  }

  public connect = async (): Promise<any> =>{

    console.log('开始链接--')


   return new Promise(async (resolve, reject) => {

      try {

        // this.eventController.trigger('connect', 'start');

        this.provider = await this.web3Modal.connect();

        this.library = getLibrary(this.provider);

        const accounts = await this.library.listAccounts();

        this.account = accounts[0];

        const {chainId} = await  this.library.getNetwork()

        this.setChainId = chainId

        console.log('this.chainId---',this.chainId)

        this.subscribeProvider(this.provider)

        resolve(this.provider);

        this.active = true

        this.eventController.trigger('connect', 'connect');

      } catch (error) {

        reject(error)

        console.log(error)

      }

    })
  }
  public resetApp =async ()=>{

    removeLocal(WEB3_USER_INFO)

    await this.web3Modal.clearCachedProvider();

    this.account = '';
    
    this.chainId = 0;

    this.library = {} as Web3Provider

    this.provider = {} as ExternalProvider | JsonRpcFetchFunc

    this.token = ''

    this.active = false

    this.eventController.trigger('connect','disconnect')
  }

  private subscribeProvider = async (provider: any):Promise<any> => {
    if (!provider.on) {

      return logger.throwArgumentError("缺少provider", "provider", provider);
    }
    provider.on("close", () => this.resetApp());

    provider.on("accountsChanged", async (accounts: string[]) => {

      this.account = accounts[0] 

      console.log('accountsChanged')

    });
    provider.on("connect", async (info:any) => {

      this.setChainId = parseInt(info.chainId);

      this.library = getLibrary(this.provider);

      const accounts = await this.library.listAccounts();

      this.account = accounts[0];

      console.log('connect===',accounts)
    });
    provider.on("chainChanged", async (chainId: number) => {

      console.log('chainChanged ==,',parseInt(chainId))

      this.setChainId = parseInt(chainId)

    });

    provider.on("networkChanged", async (networkId: number) => {

      console.log('networkChanged ==,',networkId)

      this.setChainId = networkId;

      this.library = getLibrary(this.provider);

      const accounts = await this.library.listAccounts();

      this.account = accounts[0];
   
    });
  };
  private initWeb3 = ():Web3Modal=>{

  return  new Web3Modal({
      theme: "light",
      cacheProvider: true,
      disableInjectedProvider: true,
      providerOptions: {
        "custom-metamask": {
          display: {
            logo: "data:image/png;base64,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",
            name: "Metamask",
            description: "Connect with your Metamask account"
          },
          package: window,
          options: {
            apiKey: "EXAMPLE_PROVIDER_API_KEY"
          },
          connector: async (ProviderPackage:any, options:any) => {
            let provider = null
            if (typeof window.ethereum !== "undefined") {
               provider = window.ethereum;
              try {
                await provider.request({ method: "eth_requestAccounts" });
          
              } catch (error) {
                throw new Error("User Rejected");
              }
            } else if (window.web3) {
              provider = window.web3.currentProvider;
            } else {
              // const id = localStorage.getItem('id')||''
              // openMetaMaskUrl(
              //   `https://metamask.app.link/dapp/${document.location.host}/#/login?id=${id}`
              // );
              throw new Error("No Web3 Provider found");
            }
            return provider;
          }
        },
        walletlink: {
          package: CoinbaseWalletSDK, // Required
          options: {
            appName: "NFTSTAR", // Required
            infuraId: "8d069f063bce47f4822c150d25848532", // Required unless you provide a JSON RPC url; see `rpc` below
          },
        },
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            // PANSHUO's test key
            infuraId: "8d069f063bce47f4822c150d25848532",
            qrcodeModalOptions: {
              mobileLinks: [
                "rainbow",
                "metamask",
                "argent",
                "trust",
                "imtoken",
                "pillar",
              ],
              desktopLinks: [
                "rainbow",
                "metamask",
                "argent",
                "trust",
                "imtoken",
                "pillar",
              ],
            },
          },
        },
        fortmatic: {
          package: Fortmatic,
          options: {
            // Mikko's TESTNET api key
            key: "pk_live_1640F85D3210A684",
            network: {
              rpcUrl:
                "https://mainnet.infura.io/v3/8d069f063bce47f4822c150d25848532",
              chainId: 1,
            },
          },
        },
      },
    })
  }
   /**
    *
    *
    * @param {number} total 转账金额
    * @param {funtion} callback 回调
    * @memberof Core
    */
  public buyStartCoin = async (total:number,callBack:(data:ResultData)=>void): Promise<any> =>{
    try {
      if(!WEB3_SDK_SUPPORT_CHAIN_ID?.includes(String(this.chainId))){

        console.log(WEB3_SDK_SUPPORT_CHAIN_ID?.includes(String(this.chainId)))

         await this.switchNetWork()

       // logger.throwArgumentError("不支持的链,目前紧支持 ETH 和 Polygon", "chainId", this.chainId);

      }
      console.log('this.setChainId ===',SUPPORT_CHAIN_DATA[this.chainId].chain )
      if(SUPPORT_CHAIN_DATA[this.chainId].chain == "ETH"){

        return this.sendTransactionByEth(total,callBack)

      } 
      if(SUPPORT_CHAIN_DATA[this.chainId].chain == "WETH"){

        return this.sendTransactionByWeth(total,callBack)
        
      }
    } catch (error) {
      console.log(error)
    }   
   
  }
   /**
    *
    *
    * @param {number} total 转账金额
    * @param {string} toAddress 转账抵制
    * @param {funtion} callback 回调
    * @memberof Core
    */
  private sendTransactionByWeth = (total:number,callBack:(data:ResultData)=>void): Promise<any> =>

    new Promise(async (resolve, reject) => {
      try {

         const {result} = await getConfigApi.query<BaseConfig>({otherOptions:{headers:{token:this.token}}})

         this.config =  result;

         if(!this.config.ethReceiptWalletAddress){

          logger.throwArgumentError("没有转账地址", "ethReceiptWalletAddress", this.config);
          
         }
         const accounts = await this.library.listAccounts();
   
         const account = accounts[0]
         
         const payTotal = total / this.config.ethRatio ;
         
         const transferContract = contract<Buy>(contractAddress[this.chainId].buy.address,buyApi, this.library.getSigner(account));
   
         const amount = parseEther(String( payTotal))
   
         let balance = await transferContract.balanceOf(account);
   
         let balanceTotal = formatEther(balance)
   
          const gasPrice = await this.library.getGasPrice();
   
         if(Number(balanceTotal) - payTotal <0){
   
           logger.throwArgumentError("余额不足", "sendTransactionByWeth", payTotal);
   
         }
         const limit = await transferContract.estimateGas.transfer(this.config.ethReceiptWalletAddress, amount,{ from: account})
   
         let tx =  await transferContract.transfer(this.config.ethReceiptWalletAddress, amount,{ from: account,gasLimit: (BigNumber.from(limit).toNumber() * 1.2).toFixed(0), gasPrice: ( Number(formatUnits(gasPrice, "wei")) * 1.2).toFixed(0)})

         const timer = setInterval(() => { this.loopResult(tx.hash,callBack);}, 3000);

         this.timerList.push({ id: tx.hash, timer});

         resolve(tx)

         await purchaseApi.create({data:{txHash:tx.hash,amount:parseUnits(String(payTotal)).toString(),chainType:'WETH'},otherOptions:{headers:{token:this.token}}})

        
      } catch (error) {

        reject(error)

      }
      
   }); 
   /**
    *
    *
    * @param {number} total 转账金额
    * @param {string} toAddress 转账抵制
    * @param {funtion} callback 回调
    * @memberof Core
    */
  private sendTransactionByEth = (total:number,callBack:(data:ResultData)=>void): Promise<any> =>

    new Promise(async (resolve, reject) => {

      try {

         const {result} = await getConfigApi.query<BaseConfig>({otherOptions:{headers:{token:this.token}}})

         this.config =  result;

         if(!this.config.ethReceiptWalletAddress){

          logger.throwArgumentError("没有转账地址", "ethReceiptWalletAddress", this.config);

         }
         const payTotal = total / this.config.ethRatio ;

         const accounts = await this.library.listAccounts();
   
         const account = accounts[0]
   
         const amount = parseEther(String(payTotal))
   
         const signer = this.library.getSigner()

         const balance = await this.library.getBalance(account)
   
         const balanceTotal = formatEther(balance)
   
         if(Number(balanceTotal) - payTotal<0){
   
           logger.throwArgumentError("余额不足", "sendTransactionByEth", payTotal);
   
         }
   
         const limit =  await this.library.estimateGas({from:account})

         console.log(this.config)

         const tx =  await signer.sendTransaction({ from:account,to:this.config.ethReceiptWalletAddress,value: amount,gasLimit:limit})

         const timer = setInterval(() => { this.loopResult(tx.hash,callBack);}, 3000);

         this.timerList.push({ id: tx.hash, timer});

         resolve(tx)

         await purchaseApi.create({data:{txHash:tx.hash,amount:parseUnits(String(payTotal)).toString(),chainType:'ETH'},otherOptions:{headers:{token:this.token}}})

      } catch (error) {

         reject(error)

      }
    
   }); 
   /**
    *
    *
    * @private
    * @param {string} hash
    * @param {(data:any)=>void} callBack
    * @memberof Core
    */
   private loopResult = async (hash:string,callBack:(data:any)=>void): Promise<any> =>{

    try {

      const { result } = await loopBuyVipApi.get<{[key:string]:any}>({id:hash},{headers:{token:this.token}});

      const  timer = this.getTimer(hash)
  
      if (result.orderStatus == 2) {

        this.timerList = this.timerList.filter((item) => item.id != hash);

        timer && clearInterval(timer);

        const successResult:ResultData = {
          code:0,
          message:'success',
          result:result
        }

        callBack(successResult)
      }

      if( result.orderStatus == 3|| result.failCode != 0){

        this.timerList = this.timerList.filter((item) => item.id != hash);

        timer && clearInterval(timer);

        const failResult:ResultData = {
          code:1,
          message:'fail',
          result:result
        }

        callBack(failResult)
      }
  

    } catch (error) {

      const  timer  = this.getTimer(hash)

      this.timerList = this.timerList.filter((item) => item.id != hash);

      timer && clearInterval(timer);

      logger.info('定时器已经清除',hash)

    }
  }
   private getTimer = (hash:string):any =>{

    const { timer } = this.timerList.find((item) => item.id == hash);

    return timer
  }
  private switchNetWork = async():Promise<any>=> {

    let provider = this.provider

    return new Promise(async (resolve, reject) => {
      if (provider) {
        let netID = this.chainId
        let params = {};
        if (IS_TEST_NET) {

          if (netID == 80001||netID ==4 ) {
            return resolve(true);
          } else {
            params = [
              {
                chainId: toHex(80001),
                chainName: "maticTest",
                nativeCurrency: {
                  name: "MATIC",
                  symbol: "MATIC",
                  decimals: 18,
                },
                rpcUrls: ["https://rpc-mumbai.maticvigil.com/"],
                blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
              },
            ];
          }
        } else {
          if (netID == 137|| netID == 1) {
            return resolve(true);
          } else {
            params = [
              {
                chainId: toHex(137),
                chainName: "Polygon",
                nativeCurrency: {
                  name: "MATIC",
                  symbol: "MATIC",
                  decimals: 18,
                },
                rpcUrls: ["https://polygon-rpc.com/"],
                blockExplorerUrls: ["https://polygonscan.com/"],
              },
            ];
          }
        }
        window.ethereum
          .request({
            method: "wallet_addEthereumChain",
            params: params,
          })
          .then(async (res:any) => {

            this.library = getLibrary(this.provider);

            const {chainId} = await this.library.getNetwork()

            netID = chainId

            this.setChainId = chainId

            if (IS_TEST_NET) {
              if (netID == 80001 || netID == 4) {
                return resolve(true);
              } else {
                return reject(false);
              }
            } else {
              if (netID == 137 || netID == 1) {
                return resolve(true);
              } else {
                return reject(false);
              }
            }

            //添加成功
          })
          .catch((err:any) => {
            reject(false);
            console.log(err);
            //添加失败
          });
      } else {
        return false;
      }
    });
  }

  public on(event: string, callback: (result: any) => void): () => void {
    this.eventController.on({
      event,
      callback
    });

    return () =>
      this.eventController.off({
        event,
        callback
      });
  }

  public off(event: string, callback?: (result: any) => void): void {
    this.eventController.off({
      event,
      callback
    });
  }
  


}
